import React from 'react';
import style from './ohCleoStory.module.css';
import Img from 'gatsby-image';
 

const OhCleoStory = ({ section }) => {
  const { overline, title, subTitle, body1, body2, images } = section;

  return (
    <section className={style.ohCleoStoryWrapper}>
      <div className={style.ohCleoStoryFirst}>
        <aside>
          <h3>{title}</h3>
          <p>{subTitle}</p>
        </aside>
      </div>
      <div className={style.ohCleoStorySecond}>
        <div>
          {images.map(image => (<div><Img fluid={image.fluid} alt={'App promo'}/></div>))}
        </div>
        <div>
          <h3>{overline}</h3>
          <p>
            {body1} <br /> <br /> {body2}
          </p>
        </div>
      </div>
    </section>
  );
};

export default OhCleoStory;
